export default class RequestEnableUser {
    public customerEmail!: string
    public customerStatus!: number
    public comments!: string
}